import { createContext, useState, useEffect } from "react";
import axios from "axios";



export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [is_admin, setIsAdmin] = useState(false);
    
    
    
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
   
   
     const token = localStorage.getItem("token") ? localStorage.getItem("token"): null;
        useEffect(() => { 
            // Check if token exists and set authentication status accordingly
            if (token) {
                setIsAuthenticated(true);
                const storeduser = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
                setUser(storeduser); // Set user from localStorage
                setIsAdmin(user?.is_superuser); // Set user from localStorage
            } else {
                setIsAuthenticated(false);
                setUser(null);
            }
            console.log('user:', user);
            console.log('isAuthenticated:', isAuthenticated);   
            console.log('is_admin:', is_admin);
    
          },[token, isAuthenticated, is_admin]);

         

    return (
        <AuthContext.Provider value={{user, setUser,is_admin,  isAuthenticated, setIsAuthenticated, is_admin }}>
            {children}
        </AuthContext.Provider>
    );
};
